import { Icon, Modal } from 'AlignComponents';
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { IFieldProps } from '@/UI/Interfaces/IComponent';
import { ChromePicker } from 'react-color'
import { Button, Form, InputGroup } from 'react-bootstrap';
import icons from "../IconPicker/icons"

const Field = ({ config, fieldValueChange, fieldFocusOut, uniqueKey, enable, value, validateMandatory, hideLabel }: IFieldProps) => {
  const { fieldid } = config;
  const dispatch = useAppDispatch();
  const [currentValue, setCurrentValue] = useState<string>("");

  const [fieldIsInEditing, setFieldIsInEditing] = useState<boolean>(false);

  const [iconSearch, setIconSearch] = useState<string>("");
  const [pickerState, togglePickerState] = useState<boolean>(false);

  const objectId = useAppSelector((x) => x.EntryForm.activeObjectId);

  useEffect(() => {
    if (value === undefined) {
      callBaseMethod("");
    }
  }, [value]);

  const callBaseMethod = (value: any) => {
    fieldValueChange(fieldid, value);
  }

  const change = (val: any) => {
    setCurrentValue(val);

    blur(val)
  }

  const blur = (val: any) => {
    if (val != value)
      callBaseMethod(val);

    setCurrentValue(val);
    setFieldIsInEditing(false);

    fieldFocusOut(fieldid, val);
  }

  const handleIconSearch = (e: any) => {
    setIconSearch(e.target.value);
  }

  const openPicker = () => {
    togglePickerState(true);
  }

  const closePicker = () => {
    togglePickerState(false);
  }


  const selectIcon = (e: any) => {
    var el = e.target;

    while (el.tagName.toUpperCase() != 'BUTTON') {
      el = el.parentElement;
    }

    closePicker();
    change(el.id);
  }

  var filterIcons = icons.filter((x: any) => {
    const searchSplit = iconSearch.split(" ");
    if (!iconSearch || searchSplit.filter((y: any) => x.toLowerCase().includes(y.toLowerCase())).length == searchSplit.length)
      return true;
  });

  if (!config) return <></>;
  const id = objectId + (uniqueKey ? `-${uniqueKey}` : "") + "-" + fieldid;

  return (
    <>
      {
        !hideLabel ?
          <label id={"lb-" + id} htmlFor={"field-" + id} >
            {config.fieldlabel}
            {validateMandatory ? (<span>*</span>) : null}
          </label>
          : null
      }

      <Modal
        modalSize='lg'
        heading="Pick Icon"
        show={pickerState}
        close={closePicker}
        bodyStyle={{ height: '60vh' }}
      >
        <>
          <InputGroup>
            <InputGroup.Text>
              <Icon icon="Search" size="18" />
            </InputGroup.Text>
            <Form.Control placeholder="Search" value={iconSearch} type="text" onChange={handleIconSearch} />
          </InputGroup>
          <hr />
          <div className="icon-picker-container">
            {
              filterIcons.map((icon: any) => (
                <Button id={icon} variant="icon-picker" onClick={selectIcon} style={{ width: "calc((100% - 90px) / 5)" }}>
                  <Icon icon={icon} size="18" />
                  {icon}
                </Button>
              ))
            }
          </div>
        </>
      </Modal>

      <Button variant="icon-picker" onClick={openPicker} disabled={!enable}>
        <Icon icon={currentValue ? (currentValue as any) : "Slash"} size="18" />
        {!currentValue ?
          <div>
            No Icon Selected
          </div>
          : null}
      </Button>
    </>
  )

}
export default Field;
